// Customize our own `DeviceLabelTrigger` for chime to get browser permissions for audio devices
export const deviceLabelTrigger = async (logger) => {
    //first get audio
    let audioVideoStream;
    try {
        const stream = await navigator.mediaDevices.getUserMedia({
            audio: true
        });
        audioVideoStream = stream;
    }
    catch (error) {
        if (error instanceof Error) {
            logger?.error('MeetingManager failed to get audio device permissions', {
                name: error.name,
                message: error.message,
                cause: error.cause
            });
        }
        throw error;
    }
    try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasVideoInput = devices.some((value) => value.kind === 'videoinput');
        if (hasVideoInput) {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true,
                video: true
            });
            return stream;
        }
    }
    catch (error) {
        if (error instanceof Error) {
            logger?.warn('MeetingManager failed to get video device permissions', {
                name: error.name,
                message: error.message,
                cause: error.cause
            });
        }
    }
    return audioVideoStream;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGV2aWNlTGFiZWxUcmlnZ2VyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL3VzZUNoaW1lL2RldmljZUxhYmVsVHJpZ2dlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxnR0FBZ0c7QUFDaEcsTUFBTSxDQUFDLE1BQU0sa0JBQWtCLEdBQUcsS0FBSyxFQUFFLE1BQWdCLEVBQXdCLEVBQUU7SUFDakYsaUJBQWlCO0lBQ2pCLElBQUksZ0JBQXlDLENBQUM7SUFDOUMsSUFBSSxDQUFDO1FBQ0gsTUFBTSxNQUFNLEdBQUcsTUFBTSxTQUFTLENBQUMsWUFBWSxDQUFDLFlBQVksQ0FBQztZQUN2RCxLQUFLLEVBQUUsSUFBSTtTQUNaLENBQUMsQ0FBQztRQUVILGdCQUFnQixHQUFHLE1BQU0sQ0FBQztJQUM1QixDQUFDO0lBQUMsT0FBTyxLQUFLLEVBQUUsQ0FBQztRQUNmLElBQUksS0FBSyxZQUFZLEtBQUssRUFBRSxDQUFDO1lBQzNCLE1BQU0sRUFBRSxLQUFLLENBQUMsdURBQXVELEVBQUU7Z0JBQ3JFLElBQUksRUFBRSxLQUFLLENBQUMsSUFBSTtnQkFDaEIsT0FBTyxFQUFFLEtBQUssQ0FBQyxPQUFPO2dCQUN0QixLQUFLLEVBQUUsS0FBSyxDQUFDLEtBQUs7YUFDbkIsQ0FBQyxDQUFDO1FBQ0wsQ0FBQztRQUNELE1BQU0sS0FBSyxDQUFDO0lBQ2QsQ0FBQztJQUNELElBQUksQ0FBQztRQUNILE1BQU0sT0FBTyxHQUFHLE1BQU0sU0FBUyxDQUFDLFlBQVksQ0FBQyxnQkFBZ0IsRUFBRSxDQUFDO1FBQ2hFLE1BQU0sYUFBYSxHQUFHLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxJQUFJLEtBQUssWUFBWSxDQUFDLENBQUM7UUFFM0UsSUFBSSxhQUFhLEVBQUUsQ0FBQztZQUNsQixNQUFNLE1BQU0sR0FBRyxNQUFNLFNBQVMsQ0FBQyxZQUFZLENBQUMsWUFBWSxDQUFDO2dCQUN2RCxLQUFLLEVBQUUsSUFBSTtnQkFDWCxLQUFLLEVBQUUsSUFBSTthQUNaLENBQUMsQ0FBQztZQUNILE9BQU8sTUFBTSxDQUFDO1FBQ2hCLENBQUM7SUFDSCxDQUFDO0lBQUMsT0FBTyxLQUFLLEVBQUUsQ0FBQztRQUNmLElBQUksS0FBSyxZQUFZLEtBQUssRUFBRSxDQUFDO1lBQzNCLE1BQU0sRUFBRSxJQUFJLENBQUMsdURBQXVELEVBQUU7Z0JBQ3BFLElBQUksRUFBRSxLQUFLLENBQUMsSUFBSTtnQkFDaEIsT0FBTyxFQUFFLEtBQUssQ0FBQyxPQUFPO2dCQUN0QixLQUFLLEVBQUUsS0FBSyxDQUFDLEtBQUs7YUFDbkIsQ0FBQyxDQUFDO1FBQ0wsQ0FBQztJQUNILENBQUM7SUFDRCxPQUFPLGdCQUFnQixDQUFDO0FBQzFCLENBQUMsQ0FBQyJ9